import type { PlotSeriesDataLabelsOptions } from 'highcharts';

const defaultDataLabels: PlotSeriesDataLabelsOptions = {
  format: '{point.y:.2f}',
  enabled: true,
  inside: false,
  crop: false,
  overflow: 'allow',
  allowOverlap: false,
  padding: 4,
};
Object.freeze(defaultDataLabels);

export function getDataLabels(): PlotSeriesDataLabelsOptions {
  return defaultDataLabels;
}
